<header class="bg-white border-b border-n30 px-6 py-3 flex items-center justify-between sticky top-0 z-30 w-full">

  <!-- Left: page title placeholder -->
  <div class="flex items-center gap-3">
    <h1 class="text-base font-semibold text-n900 m-0">{{ pageTitle }}</h1>
  </div>

  <!-- Right: actions -->
  <div class="flex items-center gap-2">

    <!-- Notification bell -->
    <a routerLink="/dashboard/notifications"
       class="relative flex items-center justify-center w-9 h-9 rounded-xl hover:bg-n20 transition-colors text-n400 hover:text-n700">
      <i class="ph ph-bell text-xl"></i>
    </a>

    <!-- User dropdown -->
    <div ngbDropdown placement="bottom-right" class="relative">
      <button ngbDropdownToggle
        class="flex items-center gap-2 px-3 py-1.5 rounded-xl hover:bg-n20 transition-colors border-0 bg-transparent">
        <!-- Avatar with initials -->
        <div class="w-8 h-8 rounded-full bg-b300 flex items-center justify-center text-white text-xs font-semibold flex-shrink-0">
          {{ userInitials }}
        </div>
        <!-- Name + role (hidden on mobile) -->
        <div class="hidden sm:block text-left" *ngIf="currentUser">
          <p class="text-sm font-semibold text-n900 leading-none m-0">
            {{ currentUser.firstName }} {{ currentUser.lastName }}
          </p>
          <p class="text-xs text-n400 mt-0.5 m-0">{{ currentUser.role }}</p>
        </div>
        <i class="ph ph-caret-down text-xs text-n400"></i>
      </button>

      <div ngbDropdownMenu class="rounded-xl border border-n30 shadow-lg p-1 min-w-[160px]">
        <button ngbDropdownItem (click)="logout()"
          class="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-n700 hover:bg-n10 hover:text-r300 w-full text-left">
          <i class="ph ph-sign-out text-base"></i>
          Logout
        </button>
      </div>
    </div>

  </div>
</header>
